import {SpendModeEventMapM} from "./SpendInterface";

let emergencyEventMap:SpendModeEventMapM = {
    // "1":{
    //     id:"1",
    //     name:"做爸爸挑战",
    //     belongNpc:"陌生人",
    //     simpleDesc:"",
    //     dec:"你手上拿着钱！想着你当初，在尊严挑战的趋势下你想要尝试让别人的喊你一声的冲动！于是乎，你也发起了尊严挑战",
    //     chooseArr:[
    //         {name:"发起挑战",chooseParam:{key:"prefab/WeChat/beFatherChallenge",value:0}},
    //         {name:"拒绝发起"}
    //     ],
    // },
    // "2":{
    //     id:"2",
    //     name:"发红包挑战",
    //     belongNpc:"妈妈",
    //     simpleDesc:"",
    //     dec:"过年了，妈妈把你拉入了一个群!你一看就是相亲相爱群，往常你在群里是个没有存在感的小伙子！这次你赚了钱，还不得赶紧得瑟一番",
    //     chooseArr:[
    //         {name:"点击进入",chooseParam:{key:"prefab/WeChat/redPacketChallenge",value:0}},
    //         {name:"拒绝进入"}
    //     ]
    // }
}


export default function getOneSpendEmergencyEventById(id:number|string){
    return emergencyEventMap[id];
}